module.exports = __webpack_public_path__ + "img/factory.ab5fa7d2.png";